/* eslint-disable react/no-array-index-key, react/no-danger */
import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  UncontrolledDropdown,
} from "reactstrap";
import axios from "axiosClient";
import { useUser } from "auth/useUser";
import SurveyDetailCard from "components/applications/SurveyDetailCard";
import { Colxx } from "components/common/CustomBootstrap";
import SurveyQuestionBuilder from "containers/applications/QuestionBuilder";
import Payment from "components/payment";
import { useToken } from "auth/useToken";
import LanguageDropdown from "components/LanguageDropdown";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import TrainingCard from "components/trainings/TrainingCard";
import VideoHLSWrapper from "components/video/VideoHLSWrapper";

const Home = (props) => {
  const user = useUser();
  const [token, setToken] = useToken();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [exams, setExams] = useState([{ title: "Mock Test #1" }]);
  const [trainings, setTrainings] = useState([]);
  const [paymentModal, setPaymentModal] = useState(false);
  const [playerModal, setPlayerModal] = useState(false);
  const [currentVideo, setCurrentVideo] = useState({ url: null, title: "" });

  const handleWatchVideo = (url, title) => {
    setCurrentVideo({ url, title });
    setPlayerModal(true);
  };

  const handleBuy = () => {
    setPaymentModal(true);
    // console.log("Hillo buy");
  };

  const handleLogout = () => {
    setToken(null);
    localStorage.removeItem("token");
    navigate("/login");
  };

  useEffect(() => {
    axios
      .get(`/api/my-tests/${user.user._id}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setExams(res.data.tests);
      });

    axios
      .get("/api/trainings", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setTrainings(res.data.trainings);
      })
      .catch(() => {});
  }, []);

  return (
    <div className="landing-page">
      <div className="main-container">
        <div className="content-container" id="home">
          <div className="section home">
            <div className="container">
              <div className="row home-row pt-2">
                <div className="col-12 d-block mt-3">
                  <img
                    src="/static/img/EA-vertical-white.png"
                    alt="logo"
                    className="col-xl-2 col-md-3 col-xs-4 mr-sm-5"
                    style={{ width: "10rem" }}
                  />
                </div>
              </div>
              <Card>
                <CardBody>
                  {/* <Row className="icon-cards-row mb-4">
                    <Col lg="12">
                      <Row>
                        
                        <Col md="6" xs="12" className="mt-2 mb-2"></Col>
                        <Col md="6" xs="12" className="mt-2 mb-2">
                          <GradientWithRadialProgressCard
                            icon="iconsminds-network"
                            title={`The tests you have bought`}
                            detail={`You can get the next one whenever you are ready`}
                            percent={(1 / 8) * 100}
                            progressText={"1 / 8"}
                          />
                        </Col>
                      </Row>
                      <Row className="align-items-center">
                        <Col>
                          
                        </Col>
                      </Row>
                    </Col>
                  </Row> */}
                  <div className="d-flex align-items-center justify-content-between">
                    <div></div>
                    <LanguageDropdown />
                  </div>
                  <Row className=" survey-app text-left">
                    <Colxx xxs="12" lg="4" className="mb-4">
                      <Card className="mb-4">
                        <div className="position-absolute card-top-buttons">
                          <UncontrolledDropdown>
                            <DropdownToggle
                              color=""
                              className="btn btn-header-light icon-button"
                            >
                              <i className="simple-icon-options-vertical" />
                            </DropdownToggle>
                            <DropdownMenu right>
                              <DropdownItem
                                onClick={() => navigate("/change-password")}
                              >
                                {t("changePassword")}
                              </DropdownItem>
                              <DropdownItem onClick={handleLogout}>
                                {t("logout")}
                              </DropdownItem>
                            </DropdownMenu>
                          </UncontrolledDropdown>
                        </div>
                        <CardBody>
                          <SurveyDetailCard user={user.user} />
                          <div className="text-center">
                            <Button
                              outline
                              color="primary"
                              className="mt-3"
                              onClick={() => handleBuy()}
                            >
                              <i className="iconsminds-shopping-cart btn-group-icon" />{" "}
                              {t("buyExam")}
                            </Button>
                          </div>
                        </CardBody>
                      </Card>
                    </Colxx>

                    <Colxx xxs="12" lg="8">
                      {trainings.length > 0 && (
                        <div className="mb-4">
                          <h5 className="mb-3">{t("trainings")}</h5>
                          <ul className="list-unstyled">
                            {trainings.map((training, index) => (
                              <li key={training._id}>
                                <TrainingCard
                                  order={index}
                                  training={training}
                                  onWatch={handleWatchVideo}
                                />
                              </li>
                            ))}
                          </ul>
                          <h5 className="mb-3">{t("mockExams")}</h5>
                        </div>
                      )}
                      <ul className="list-unstyled mb-4">
                        {exams.length > 0 &&
                          exams.map((item, index) => {
                            return (
                              <li data-id={item.id} key={item.id}>
                                <SurveyQuestionBuilder
                                  order={index}
                                  item={item}
                                  expanded={!item.userId && true}
                                />
                              </li>
                            );
                          })}
                      </ul>
                    </Colxx>
                  </Row>
                </CardBody>
              </Card>
            </div>
          </div>
          <Modal
            isOpen={paymentModal}
            size="lg"
            toggle={() => setPaymentModal(!paymentModal)}
          >
            <ModalHeader>{t("makePayment")}</ModalHeader>
            <ModalBody>
              <Payment user={user.user} token={token} />
            </ModalBody>
          </Modal>

          <Modal
            isOpen={playerModal}
            size="xl"
            toggle={() => setPlayerModal(false)}
          >
            <ModalHeader toggle={() => setPlayerModal(false)}>
              {currentVideo.title}
            </ModalHeader>
            <ModalBody style={{ background: "#000", padding: 0 }}>
              {playerModal && <VideoHLSWrapper key={currentVideo.url} src={currentVideo.url} />}
            </ModalBody>
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default Home;
